import { render, staticRenderFns } from "./GroupStatusCard.vue?vue&type=template&id=71fab7a2&scoped=true"
import script from "./GroupStatusCard.vue?vue&type=script&lang=js"
export * from "./GroupStatusCard.vue?vue&type=script&lang=js"
import style0 from "./GroupStatusCard.vue?vue&type=style&index=0&id=71fab7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fab7a2",
  null
  
)

export default component.exports